import axios from "axios";
import store from "../store";
import { setError, clearError } from "../store/slices/errorSlice";
import { expireSession, isSessionExpiredError } from "@/utils/session";

const resolveBaseURL = () => {
  const envBase = import.meta.env.VITE_API_BASE_URL;
  if (envBase) return envBase.replace(/\/$/, "");

  if (typeof window !== "undefined") {
    const { protocol, hostname } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return `${protocol}//${hostname}:4000/api`;
    }
    return `${protocol}//${hostname}/api`;
  }

  return "http://localhost:8000/api";
};

const axiosClient = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 120000,
});

axiosClient.interceptors.request.use((config) => {
  // Check for both normal user token and super admin token
  const token = localStorage.getItem("auth_token") || localStorage.getItem("authToken") || localStorage.getItem("superAdminToken");

  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

axiosClient.interceptors.response.use(
  (res) => {
    store.dispatch(clearError());
    return res;
  },
  (err) => {
    // Expired/invalid token — log out instead of surfacing errors on every screen
    if (isSessionExpiredError(err)) {
      expireSession();
      return Promise.reject(err);
    }
    const message = err?.response?.data?.message || err?.message || "Something went wrong";
    store.dispatch(setError(message));
    return Promise.reject(err);
  }
);

export default axiosClient;
